import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { PremiumService } from '../../api';
import { setNotification } from '../../utils/notificationUtils';
import { INFO } from '../../layouts/notification/Notification';

export const uploadPremium =
  (file: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });

    new PremiumService()
      .importBexPremium(file)
      .then((response: any) => {
        dispatch({
          type: ActionTypes.IMPORT_PREMIUM,
          payload: response.data,
        });
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
        setNotification('Datei erfolgreich importiert', [], INFO, 10000);
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };
